var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileBuble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(-3449.37 -178.63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3455.34 216.61q-6.14-33 26.58-33c32.71 0 44.35 15.92 45.41 28.88s-18 39.47-41.78 37q-23.76-2.55-30.21-32.88Z",
    style: {
      clipRule: "evenodd",
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    transform: "translate(-3449.37 -178.63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2078.47h1722L4055.38 0h-1722L0 2078.47z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h83v76H0z",
    style: {
      fill: "#fff"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBuble);
export default __webpack_public_path__ + "static/media/profile-buble.2e8a98ad3e75d7c4239fd8303c689fb1.svg";
export { ForwardRef as ReactComponent };